import { DualAxes } from '@ant-design/charts'
import { Col, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const SaleTabDashBoardStyled = styled.div`
    background-color: white;

    .ant-tabs-tab {
        padding: 16px 0;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
    }
    .ant-tabs-nav-wrap {
        margin-left: 24px;
    }
    .title-sale-tab {
        width: 100%;
        margin-bottom: 20px;

        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
`

export default function SaleTabDashboard({ dataSalesTrend, getTypeLabel }) {
  const [trans] = useTranslation(['dashboard'])

  const [salesTrend, setSalesTrend] = useState([])
  const [salesGrowth, setSalesGrowth] = useState([])

  const config = {
    data: [salesTrend, salesGrowth],
    xField: 'time',
    yField: ['value', 'value'],
    yAxis: {
      value: {
        tickCount: 10
      }
    },
    xAxis: {
      line: { style: {
        stroke: '#6d6d6d',
        shadowColor: '#6d6d6d'
      } }
    },
    height: 254,
    legend: false,
    tooltip: {
      formatter: (datum) => {
        if (datum.type === 'growth') {
          return { name: datum.type, value: `${datum.value.toFixed(2)}%` }
        }
        return { name: datum.type, value: `${datum.value}` }
      },
      customItems: (originalItems) => originalItems.filter((item) => item.name)
    },
    geometryOptions: [
      {
        geometry: 'column',
        seriesField: 'type',
        maxColumnWidth: 50,
        minColumnWidth: 10,
        color: ['#58AFFF'],
        label: {
          content: ''
          // formatter: (text) => {
          //   if (text.type === 'growth') {
          //     return text.value ? `${(text.value).toFixed(2)}%` : ''
          //   }
          //   return ''
          // }
        }
      },
      {
        geometry: 'line',
        color: 'red',
        seriesField: 'type',
        label: {
          content: ''
        }
      }
    ]
  }

  useEffect(() => {
    if (dataSalesTrend && dataSalesTrend?.chart?.length > 0) {
      const dataChartSaleTrend = dataSalesTrend?.chart
      const arrDataAmount = []
      const arrDataGrowth = []
      for (let i = 0; i < dataChartSaleTrend?.length; i += 1) {
        const itemAmount = {
          time: getTypeLabel(dataChartSaleTrend[i]),
          type: 'amount',
          value: dataChartSaleTrend[i].totalAmount
        }
        const base = dataChartSaleTrend[i - 1] ? dataChartSaleTrend[i - 1]?.totalAmount : dataSalesTrend?.baseSaleTrend
        const itemGrowth = {
          time: getTypeLabel(dataChartSaleTrend[i]),
          type: 'growth',
          value: base
            ? ((dataChartSaleTrend[i].totalAmount - base) / base) * 100
            : 0
        }
        arrDataGrowth.push(itemGrowth)
        arrDataAmount.push(itemAmount)
      }
      setSalesGrowth(arrDataGrowth)
      setSalesTrend(arrDataAmount)
    }
  }, [dataSalesTrend])

  return (
    <SaleTabDashBoardStyled>
      <Row>
        <Col sm={0} xl={4} />
        <Col sm={24} xl={16}>
          <div className="title-sale-tab">
            <span>{trans('dashboard:salesTrend')}</span>
            <span>{trans('dashboard:growthRate')}</span>
          </div>
          <DualAxes {...config} />
        </Col>
        <Col sm={0} xl={4} />
      </Row>
    </SaleTabDashBoardStyled>
  )
}

SaleTabDashboard.propTypes = {
  dataSalesTrend: PropTypes.any,
  getTypeLabel: PropTypes.func
}
